import styles from './PoliticaCheckbox.module.css';

// Casilla de autorización del tratamiento de datos (Ley 1581 de 2012, art. 9 y 12). La usan las pantallas
// donde una cuenta se activa (registro y cambio de clave temporal): el texto legal es UNO solo.
// Base configurable con REACT_APP_LANDING_URL (en local, la landing); sin ella, producción.
// Con barra final: la landing redirige (308) la versión sin ella.
const LANDING_URL = (process.env.REACT_APP_LANDING_URL || 'https://eventifycol.com').replace(/\/+$/, '');
const PRIVACY_URL = LANDING_URL + '/tratamiento-datos/';

export default function PoliticaCheckbox({ checked, onChange }) {
  return (
    <label className={styles.casilla}>
      <input type="checkbox" checked={checked} onChange={e => onChange(e.target.checked)} />
      <span>
        Autorizo el tratamiento de mis datos personales para crear y administrar mi cuenta y
        participar en las asambleas, según la{' '}
        <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer">Política de Tratamiento de Datos Personales</a>
        , donde encuentras tus derechos (consultar, actualizar, rectificar y suprimir tus datos). *
      </span>
    </label>
  );
}
